// Reminder message templates keyed by tone
export function buildReminderMessage({ tone, borrowerName, lenderName, outstanding, dueDate, loanUrl }) {
  const dueStr = dueDate
    ? new Date(dueDate).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })
    : "";

  const amtStr = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(outstanding || 0);

  if (tone === "friendly") {
    return (
      `Hi ${borrowerName} 👋\n\n` +
      `Just a gentle reminder about the loan of ${amtStr} that's due on ${dueStr}. ` +
      `No stress — whenever you're ready, please transfer via UPI and share the reference.\n\n` +
      `Details: ${loanUrl}\n\n` +
      `— ${lenderName}`
    );
  }
  if (tone === "firm") {
    return (
      `Hi ${borrowerName},\n\n` +
      `This is a follow-up on the outstanding amount of ${amtStr} due on ${dueStr}. ` +
      `Kindly clear this at the earliest and share the UPI reference number.\n\n` +
      `Loan details: ${loanUrl}\n\n` +
      `Thanks,\n${lenderName}`
    );
  }
  // final
  return (
    `${borrowerName},\n\n` +
    `Final reminder: an amount of ${amtStr} is outstanding, past its due date (${dueStr}). ` +
    `Please clear the dues immediately or contact me today to agree on a settlement plan. ` +
    `Continued non-payment will require further action.\n\n` +
    `Loan record: ${loanUrl}\n\n` +
    `— ${lenderName}`
  );
}
